<div class=" overflow-auto" style="height: calc(92vh - 110px);">
    <p-tabs [(value)]="currTabActiveId">
        <p-tablist>
            <p-tab value="0">
                Overview
            </p-tab>
            <p-tab value="1">
                Activity
            </p-tab>
            <p-tab value="2">
                Files Shared
            </p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="0" [style]="{'padding': '0px'}">
                <!-- Container Card -->
                <div class="p-4 ticket-middle-view-card" *ngIf="ticket">
                    <h4>
                        {{ticket?.title || 'No Title'}}
                    </h4>
                    <div class="flex items-center gap-2 mb-3">
                        <div class="flex items-center gap-2">
                            <div>
                                <p-avatar label={{ticket.initials}}
                                    [style]="{'height': '30px', 'width': '30px', 'borderRadius': '50%'}" shape="circle"
                                    class="mr-2"></p-avatar>
                            </div>
                            <div>
                                <strong>
                                    {{ticket?.name}}
                                </strong><br>
                                <small>{{ticket?.timeAgo}}</small>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div>
                        <div class="p-text-bold"> {{ticket?.ticket_desc || 'No description provided'}}</div>
                    </div>
                    <hr *ngIf="ticket?.attachments?.length > 0">
                    <div *ngIf="ticket?.attachments?.length > 0">
                        <b>Attachments ({{ ticket?.attachments?.length || 0 }})</b>
                        <div *ngIf="ticket.attachments?.length > 0" class="flex flex-wrap gap-4 mt-4 justify-start">
                            <a *ngFor="let fileUrl of ticket.attachments" [href]="fileUrl" target="_blank"
                                class="flex flex-col items-center w-24 p-2 transition-all duration-200 ease-in-out transform rounded-lg hover:scale-105 hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500">

                                <div
                                    class="relative flex items-center justify-center w-16 h-16 mb-2 overflow-hidden bg-gray-200 rounded-md dark:bg-gray-700">
                                    <ng-container [ngSwitch]="getFileType(fileUrl)">

                                        <ng-container *ngSwitchCase="'image'">
                                            <img [src]="fileUrl" alt="Image thumbnail"
                                                class="object-cover w-full h-full"
                                                onerror="this.style.display='none'; this.closest('div').querySelector('.file-icon').style.display='flex';">
                                            <!-- <i class="pi pi-image text-gray-500 text-3xl absolute file-icon hidden"></i> -->
                                        </ng-container>

                                        <ng-container *ngSwitchCase="'video'">
                                            <i class="pi pi-video text-blue-500 text-4xl"></i>
                                        </ng-container>

                                        <ng-container *ngSwitchCase="'pdf'">
                                            <i class="pi pi-file-pdf text-red-500 text-4xl"></i>
                                        </ng-container>

                                        <ng-container *ngSwitchDefault>
                                            <i class="pi pi-file text-gray-500 text-4xl"></i>
                                        </ng-container>
                                    </ng-container>
                                </div>

                                <div class="w-full text-xs font-medium text-center text-gray-700 truncate dark:text-gray-300"
                                    [title]="getFileName(fileUrl)">
                                    {{ getFileName(fileUrl) }}
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

                <div class="p-4 ticket-middle-view-card" *ngIf="!ticket">
                    <div class="flex justify-center items-center mt-10">
                        <p-progressSpinner strokeWidth="2" styleClass="w-4rem h-4rem"></p-progressSpinner>
                    </div>
                </div>


            </p-tabpanel>
            <p-tabpanel value="1" [style]="{'padding': '0px'}">
                <app-ticket-activity-tab [currTabActiveId]="currTabActiveId"  [ticket]="ticket"></app-ticket-activity-tab>
            </p-tabpanel>
            <p-tabpanel value="2" [style]="{'padding': '1rem'}">
                <div class="files-shared-container">
                    <div class="flex justify-between items-center mb-4">
                        <h3 class="text-lg font-semibold">
                            Files Shared ({{ ticket?.attachments?.length }})
                        </h3>
                        <p-button icon="pi pi-plus" label="Add File" size="small" (click)="showAddFileDialog = true">
                        </p-button>
                    </div>

                    <div *ngIf="ticket?.attachments?.length > 0" class="attachments-grid">
                        <div *ngFor="let fileUrl of ticket.attachments" class="attachment-card">

                            <!-- File Thumbnail/Icon -->
                            <div class="attachment-icon-container">
                                <ng-container [ngSwitch]="getFileType(fileUrl)">

                                    <!-- Image -->
                                    <ng-container *ngSwitchCase="'image'">
                                        <img [src]="fileUrl" alt="Image thumbnail" class="attachment-thumbnail"
                                            onerror="this.style.display='none'; this.nextElementSibling.style.display='block';">
                                        <i class="pi pi-image attachment-icon-fallback" style="display: none;"></i>
                                    </ng-container>

                                    <!-- Video -->
                                    <ng-container *ngSwitchCase="'video'">
                                        <i class="pi pi-video attachment-icon"></i>
                                    </ng-container>

                                    <!-- PDF -->
                                    <ng-container *ngSwitchCase="'pdf'">
                                        <i class="pi pi-file-pdf attachment-icon"></i>
                                    </ng-container>

                                    <!-- Default -->
                                    <ng-container *ngSwitchDefault>
                                        <i class="pi pi-file attachment-icon"></i>
                                    </ng-container>
                                </ng-container>
                            </div>

                            <!-- File Info -->
                            <div class="attachment-info">
                                <div class="attachment-name" [title]="getFileName(fileUrl)">
                                    {{ getFileName(fileUrl) }}
                                </div>
                            </div>

                            <!-- Action Buttons -->
                            <div class="attachment-actions">
                                <p-button icon="pi pi-eye" size="small" [text]="true"
                                    (click)="viewAttachment(fileUrl); $event.stopPropagation()" title="View">
                                </p-button>
                                <p-button icon="pi pi-download" size="small" [text]="true"
                                    (click)="downloadAttachment(fileUrl); $event.stopPropagation()" title="Download">
                                </p-button>
                            </div>
                        </div>
                    </div>

                    <!-- Empty State -->
                    <div *ngIf="ticket?.attachments?.length === 0" class="empty-state">
                        <i class="pi pi-file-o empty-icon"></i>
                        <h4>No files shared yet</h4>
                        <p>Files attached to this ticket will appear here</p>
                        <p-button label="Add First File" icon="pi pi-plus" (click)="showAddFileDialog = true">
                        </p-button>
                    </div>
                </div>
            </p-tabpanel>


        </p-tabpanels>
    </p-tabs>
</div>

<!-- Image Viewer Dialog -->
<p-dialog [visible]="showImageViewer" [modal]="true" [closable]="true" [maximizable]="true"
    [style]="{ width: '80vw', height: '80vh' }" (onHide)="closeImageViewer()">
    <ng-template pTemplate="header">
        <span>{{ selectedAttachment?.name }}</span>
    </ng-template>

    <div class="image-viewer-content">
        <img *ngIf="selectedAttachment?.type === 'image'" [src]="selectedAttachment.url" [alt]="selectedAttachment.name"
            class="max-w-full max-h-full object-contain">

        <div *ngIf="selectedAttachment?.type === 'video'" class="video-container">
            <video [src]="selectedAttachment.url" controls class="max-w-full max-h-full">
                Your browser does not support the video tag.
            </video>
        </div>

        <div *ngIf="selectedAttachment?.type !== 'image' && selectedAttachment?.type !== 'video'" class="file-preview">
            <i class="pi pi-file text-6xl text-gray-400 mb-4"></i>
            <p class="text-lg font-medium">{{ selectedAttachment?.name }}</p>
            <p class="text-gray-600 mb-4">{{ selectedAttachment?.size }}</p>
            <div class="flex gap-2">
                <p-button label="Open in Browser" icon="pi pi-external-link"
                    (click)="openInBrowser(selectedAttachment)">
                </p-button>
                <p-button label="Download" icon="pi pi-download" [outlined]="true"
                    (click)="downloadAttachment(selectedAttachment)">
                </p-button>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-between w-full">
            <div>
                <p-button label="Download" icon="pi pi-download" [outlined]="true"
                    (click)="downloadAttachment(selectedAttachment)">
                </p-button>
            </div>
            <div>
                <p-button label="Close" icon="pi pi-times" (click)="closeImageViewer()">
                </p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="showAddFileDialog" [modal]="true" [closable]="true" header="Add Attachments"
    [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" (onHide)="onDialogClose()">

    <div class="dialog-content">
        <input type="file" multiple (change)="onFileSelected($event)" #fileInput hidden />

        <div (click)="fileInput.click()"
            class="flex flex-col items-center justify-center p-8 border-2 border-dashed rounded-lg cursor-pointer text-gray-500 hover:bg-gray-50 hover:border-gray-400 transition-colors">
            <i class="pi pi-cloud-upload text-4xl mb-3"></i>
            <p class="font-semibold">Drag and drop files here, or click to browse</p>
            <p class="text-sm">Supports Images, Videos, and PDFs</p>
        </div>

        <div *ngIf="totalFiles.length > 0" class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
            <div *ngFor="let file of totalFiles; let i = index"
                class="group relative bg-white rounded-lg shadow border transition-all hover:shadow-lg">

                <div class="relative aspect-square w-full overflow-hidden rounded-t-lg">
                    <img *ngIf="isImage(file.file.name)" [src]="file.preview"
                        class="w-full h-full object-cover transition-transform duration-200 group-hover:scale-105"
                        alt="Image preview" />

                    <video *ngIf="isVideo(file.file.name)" [src]="file.preview"
                        class="w-full h-full object-cover rounded-t-lg" muted playsinline></video>

                    <div *ngIf="isPDF(file.file.name)"
                        class="flex items-center justify-center w-full h-full bg-gray-50 rounded-t-lg">
                        <i class="pi pi-file-pdf text-red-500 text-8xl" style="font-size: 50px;"></i>
                    </div>

                    <div
                        class="absolute top-1 right-1 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-red-200 rounded-full w-8 h-8 p-3">
                        <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger p-button-text"
                            (click)="removeFile(i); $event.stopPropagation()"></p-button>
                    </div>
                </div>

                <div class="p-2 text-center bg-gray-50 rounded-b-lg">
                    <span class="text-xs font-medium text-gray-700 truncate block" [title]="file.file.name">
                        {{ file.file.name }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 mt-4">
            <p-button label="Cancel" [outlined]="true" (click)="showAddFileDialog = false"></p-button>
            <p-button label="Save Attachments" [loading]="" [disabled]="totalFiles.length === 0"
                (click)="saveAttachments()"></p-button>
        </div>
    </ng-template>


</p-dialog>